<template>
  <div>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :showSearchForm="false"
               tableApi="admin/my_company/fuelEconomyOrders"
    >
    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "lists",
    props:{
      card_id:{
        type:Number,
        default:0
      }
    },
    components:{pageTable},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        editOrderId:0,     //编辑的ID
        showOrderDetail:false,
        searchData: {
          card_id: this.card_id,
        },
        tableColumn: [
          {title:'车牌',key: 'car_number',align: "center"},
          {title:'本次加注量',key:'litre_num',align:'center'},
          {title:'开始公里数',key:'prev_mileage',align:'center'},
          {title:'终止公里数',key:'mileage',align:'center'},
          {title:'油耗',key:'fuel_economy',align:'center'},
          {title:'下单时间',key:'create_time',align:'center',width:180},
        ],
      }
    },
    methods: {

    },
    mounted() {

    },
  }
</script>

<style scoped>

</style>
